var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import Loading from '../../../Loading/Loading';
import './PageMessage.css';
export default function PageMessage(_a) {
    var message = _a.message;
    var _b = useState(true), showMessage = _b[0], setShowMessage = _b[1];
    var _c = useState(), debounced = _c[0], setDebounced = _c[1];
    //Show new messages and then hide them after 4s
    useEffect(function () {
        setShowMessage(true);
        clearTimeout(debounced);
        if (message && (!message.sticky)) {
            var hideCommand = setTimeout(function () {
                setShowMessage(false);
            }, 4000);
            setDebounced(hideCommand);
        }
    }, [message]);
    if ((!(message === null || message === void 0 ? void 0 : message.content)) || (!showMessage)) {
        return null;
    }
    function messageClickHandler() {
        if (message === null || message === void 0 ? void 0 : message.onClick) {
            message.onClick();
        }
    }
    var messageClass = message.onClick ? 'clickable' : '';
    return (_jsx("div", __assign({ className: "PageMessage flexX" }, { children: _jsxs("div", __assign({ className: 'message ' + messageClass, style: __assign({ color: message.color, borderColor: message.color }, message.style), onClick: messageClickHandler }, { children: [_jsxs("span", __assign({ className: "loadingContainer" }, { children: [message.loading ? _jsx(Loading, {}, void 0) : null, message.icon ? _jsx(FontAwesomeIcon, { icon: message.icon }, void 0) : null] }), void 0), message.content] }), void 0) }), void 0));
}
//# sourceMappingURL=PageMessage.js.map